if (typeof JW === 'undefined') JW = {};
JW.ClsAcc = function ($, acc)
{
    var _pri = {};
    var publ = {};

    _pri.cname          = 'CLSACC';
    _pri.uid            = '';
    _pri.opts           =   {
                                dbg_lvl: 1
                            };
    _pri.inited         = false;
    _pri.page           = null;
    _pri.sections       = {};
    _pri.selected       = {};
    _pri.cl_tags_select = null;
    _pri.$dst_inp       = null;
    _pri.$dst_dsp       = null;
    _pri.$acc           = null;

    _pri.extend = function()
    {
        JW.ExtCommon(jQuery, publ, _pri);
    };

    _pri.init = function()
    {
        _pri.dbg('*** init()');
        if (_pri.inited)
        {
            _pri.dbg('    already inited - return.');
            return;
        }
        _pri.inited = true;

        _pri.$acc = $(acc);
        if (1 != _pri.$acc.length)
        {
            _pri.dbg('!!! wrong acc length! - return.');
            _pri.$acc = null;
            return;
        }

        if (typeof _pri.$acc.data('clsacc') !== 'undefined')
        {
            _pri.dbg('!!! data.clsacc already defined? - try to delete ...');
            // return;
            _pri.$acc.removeData('clsacc');
        }

        _pri.page = JW.Page;
        _pri.uid = _pri.page.getUId();

        var $sections = _pri.$acc.find('> .card');
        $.each($sections, function(k, v) {
            _pri.initSection($(v));
        });

        publ.updSection('cl_scopes');

        _pri.$acc.data('clsacc', publ);

    };

    publ.hasSection = function(key)
    {
        return (typeof _pri.sections[key] === 'object');
    };

    publ.getFormData = function()
    {
        // _pri.dbg('*** getFormData()');
        var form_data = {};
        $.each(_pri.sections, function(key, $v) {
            // _pri.dbg('    key: ', key);
            switch(key)
            {
                case 'cl_scopes':
                case 'cl_times':
                case 'cl_hireds_job':
                case 'cl_hireds_edu':
                case 'cl_poss':
                case 'cl_profs':
                    var inps = $v.find('input[type="checkbox"]');
                    var arr = inps.serializeArray();
                    var len = arr.length;
                    var i, o;
                    for (i = 0; i < len; ++i)
                    {
                        o = arr[i];
                        // _pri.dbg('    name, value ', o.name, o.value.toString());
                        if (!form_data.hasOwnProperty(o.name))
                        {
                            form_data[o.name] = o.value.toString();
                        }
                        else
                        {
                            form_data[o.name] += ',' + o.value.toString();
                        }
                    }
                break;

                case 'cl_jobs':
                    var inps = $v.find('input[type="checkbox"]');
                    var arr = inps.serializeArray();
                    var len = arr.length;
                    var i, o;
                    for (i = 0; i < len; ++i)
                    {
                        o = arr[i];
                        // _pri.dbg('    name, value ', o.name, o.value.toString());
                        if (!form_data.hasOwnProperty(o.name))
                        {
                            form_data[o.name] = o.value.toString();
                        }
                        else
                        {
                            form_data[o.name] += ',' + o.value.toString();
                        }
                    }
                break;

                case 'cl_tags':
                    var map = _pri.cl_tags_select.getItemsMap();
                    //_pri.dbg('map', map);
                    var ks = Object.keys(map);
                    var len = ks.length;
                    if (len > 0)
                    {
                        for (i = 0; i < len; ++i)
                        {
                            if (i == 0)
                            {
                                form_data['cl_tags'] = encodeURIComponent(map[ks[i]].txt);
                            }
                            else
                            {
                                form_data['cl_tags'] += ',' + encodeURIComponent(map[ks[i]].txt); // no nneed for escaping ',' because input has already been split by ','
                            }
                        }
                    }
                break;

                case 'cl_dist':
                    var $inp = $v.find('input[name="dist-inp"]');
                    if ($inp.length > 0)
                    {
                        form_data['dist'] = $inp.val().toString();
                    }
                break;

                default:

                break;
            }
        });

        // _pri.dbg('    form_data:', form_data);
        return form_data;
    };

    publ.getSection = function(key)
    {
        if (typeof _pri.sections[key] === 'object')
        {
            return _pri.sections[key];
        }
        return [];
    };

    publ.openSection = function(key)
    {
        _pri.dbgG('*** openSection()');

        if (typeof _pri.sections[key] === 'object')
        {
            _pri.sections[key].addClass('opn');
            _pri.sections[key].find('.collapse').first().collapse('show');
        }
    };

    publ.updSection = function(key)
    {
        _pri.dbgG('*** publ.updSection()');
        if (typeof _pri.sections[key] === 'object')
        {
            _pri.updSection(_pri.sections[key]);
        }
    };

    publ.upd = function()
    {
        $.each(_pri.sections, function(key, $v) {
            _pri.updSection($v);
        });
    };

    publ.setInvalid = function(key)
    {
        if (typeof _pri.sections[key] === 'object')
        {
            var $section = _pri.sections[key];
            $section.find('> .card-header').addClass('is-invalid');
            publ.openSection(key);
        }
    };

    publ.scrollTo = function(key)
    {
        if (typeof _pri.sections[key] === 'object')
        {
            var $section = _pri.sections[key];
            var $elm = $section.find('> .card-header');
            _pri.page.scrollToElm($elm);
        }
    };

    _pri.setSelectedCnt = function(key, cnt)
    {
        _pri.selected[key].cnt = cnt;
    };

    _pri.updSection = function($section, el)
    {
        var key  = $section.data('key');
        // _pri.dbg('*** updSection() key:', key, $section);

        var $lnk = $section.find('> .card-header');
        var $hdl = $lnk.find('> .chdl');
        var txt  = $hdl.text().replace(/ \(\d+\)$/, '');
        switch(key)
        {
            case 'cl_scopes':

                var scope01 = $section.find('#scope01:checked').length > 0;
                var scope03 = $section.find('#scope03:checked').length > 0;

                if (publ.hasSection('cl_hireds_job'))
                {
                    if (scope01)
                    {
                        _pri.hideSection('cl_hireds_job', false);
                    }
                    else
                    {
                        _pri.hideSection('cl_hireds_job', true);
                    }
                }

                if (publ.hasSection('cl_hireds_job'))
                {
                    if (scope03)
                    {
                        _pri.hideSection('cl_hireds_edu', false);
                    }
                    else
                    {
                        _pri.hideSection('cl_hireds_edu', true);
                    }
                }

                var len = $section.find('input[type="checkbox"]:checked').length;
                _pri.setSelectedCnt(key, len);
                if (len > 0)
                {
                    txt = txt + ' (' + len + ')';
                    $lnk.addClass('hi');
                }
                else
                {
                    $lnk.removeClass('hi');
                }
                $hdl.text(txt);
            break;
            case 'cl_times':
            case 'cl_hireds_job':
            case 'cl_hireds_edu':
            case 'cl_poss':
                var len = $section.find('input[type="checkbox"]:checked').length;
                _pri.setSelectedCnt(key, len);
                if (len > 0)
                {
                    txt = txt + ' (' + len + ')';
                    $lnk.addClass('hi');
                }
                else
                {
                    $lnk.removeClass('hi');
                }
                $hdl.text(txt);
            break;

            case 'cl_profs':
                // _pri.dbg('    upd profs ...');
                if (typeof el !== 'undefined')
                {
                    // _pri.dbg('    el ok');
                    var $cb = $(el);
                    if ($cb.attr('id').match(/^cl_profs_0_/))
                    {
                        // _pri.dbg('    matched level0 ... select sub by parent key ...');
                        var $sub = $section.find('[data-pk="' + $cb.val() + '"]');
                        if ($sub.length > 0)
                        {
                            if (el.checked)
                            {
                                $sub.collapse('show');
                            }
                            else
                            {
                                $sub.find('input[type="checkbox"]:checked').prop('checked', false);
                                $sub.collapse('hide');
                            }
                        }
                    }
                }

                var len = $section.find('input[type="checkbox"]:checked').length;
                _pri.setSelectedCnt(key, len);
                if (len > 0)
                {
                    txt = txt + ' (' + len + ')';
                    $lnk.addClass('hi');
                }
                else
                {
                    $lnk.removeClass('hi');
                }
                $hdl.text(txt);
            break;

            case 'cl_jobs':

                _pri.dbg('    cl_jobs ...');
                let $tree = $section.find('#cltree');

                if ($tree.length == 1)
                {
                    _pri.dbg('    $tree found ...');

                    let cltree = $tree.data('inst');
                    if (_pri.isObj(cltree))
                    {
                        _pri.dbg('    inst is obj ...');

                        if (cltree.cnt_all > 0)
                        {
                            txt = txt + ' (' + cltree.cnt_all + ')';
                            $lnk.addClass('hi');
                        }
                        else
                        {
                            $lnk.removeClass('hi');
                        }
                        $hdl.text(txt);

                    }
                    else
                    {
                        _pri.dbgR('    ! inst not found!');
                    }
                }

            break;

            case 'cl_tags':
                $section.find('select[name="cl_tags"]').change();
                var map = _pri.cl_tags_select.getItemsMap();
                //_pri.dbg('map', map);
                var ks = Object.keys(map);
                var len = ks.length;
                _pri.setSelectedCnt(key, len);
                if (len > 0)
                {
                    txt = txt + ' (' + len + ')';
                    $lnk.addClass('hi');
                }
                else
                {
                    $lnk.removeClass('hi');
                }
                $hdl.text(txt);
            break;

            case 'cl_dist':
                // we would have to update this on slide, not only here ... but do we want this at all?
                // var $inp = $section.find('input[name="dist-inp"]');
                // if ($inp.length > 0)
                // {
                //     txt = txt + ' (' + $inp.val().toString() + ' km)';
                //     $hdl.text(txt);
                // }
                // var $inp = $section.find('input[name="dist-inp"]');
                // if ($inp.length > 0 && typeof $inp.rangeslider === 'function')
                // {
                //     $inp.rangeslider('update', true);
                // }
                // if (_pri.$dst_inp.length > 0)
                // {
                //     _pri.dbg('        now! ...');
                //     _pri.$dst_inp.rangeslider('update', true);
                // }
            break;

            default:

            break;
        }
    };

    // _pri.updDstSld = function(pos, val)
    // {
    //     // _pri.dbg('updDstSld()', pos, val);
    //     // var $this = $(this);
    //     // _pri.dbg(this);
    //     if (typeof this.options.$lgd_cur !== 'undefined' && this.options.$lgd_cur.length == 1)
    //     {
    //         var $section = publ.getSection('cl_dist');
    //         var $lnk = $section.find('> .card-header');
    //         var $hdl = $lnk.find('> .chdl');
    //         var txt  = $hdl.text().replace(/ \(\d+ km\)$/, '');
    //         var dist_val = val + ' ' + this.options.unt;
    //         txt = txt + ' (' + dist_val + ')';
    //         $hdl.text(txt);
    //         // $lnk.addClass('hi');
    //         this.options.$lgd_cur.html(dist_val);
    //     }
    // };

    _pri.updDstSld = function($sld)
    {
        if (_pri.isObj(_pri.$dst_dsp))
        {
            let $section = publ.getSection('cl_dist');
            let $lnk = $section.find('> .card-header');
            let $hdl = $lnk.find('> .chdl');
            let txt  = $hdl.text().replace(/ \(\d+ km\)$/, '');
            let dist_val = $sld.val() + ' km';
            txt = txt + ' (' + dist_val + ')';
            $hdl.text(txt);
            // $lnk.addClass('hi');
            _pri.$dst_dsp.html(dist_val);
        }
    };

    _pri.initSection = function($section)
    {
        var key  = $section.data('key');
        _pri.dbgG('*** initSection() key:', key);

        if (typeof key === 'string' && '' != key)
        {
            _pri.sections[key] = $section;
            _pri.selected[key] = {cnt: 0};
        }
        switch(key)
        {
            case 'cl_scopes':
            case 'cl_times':
            case 'cl_hireds_job':
            case 'cl_hireds_edu':
            case 'cl_poss':
            case 'cl_jobs':
                $section.find('input[type="checkbox"]').change(function(e) {
                    _pri.updSection($section);
                });
                _pri.updSection($section);
            break;

            case 'cl_profs':
                $section.find('.sub-1.collapse').on('hidden.bs.collapse shown.bs.collapse', function(e) {
                    // _pri.dbg('*** on hidden/shown ...');
                    var $this = $(this);
                    var checked = $('#cl_profs_0_' + $this.data('pk')).is(':checked');
                    // _pri.dbg('    checked', checked);
                    // _pri.dbg('    e.type', e.type);
                    if (checked && e.type == 'hidden')
                    {
                        // _pri.dbg('*** missmatch ... show');
                        $this.collapse('show');
                    }
                    else if (!checked && e.type == 'shown')
                    {
                        // _pri.dbg('*** missmatch ... hide');
                        $this.collapse('hide');
                    }
                });
                $section.find('input[type="checkbox"]').change(function(e) {
                    _pri.updSection($section, this);
                });
                $selected0 = $section.find('input[id^="cl_profs_0_"][type="checkbox"]:checked');
                $.each($selected0, function(k, v) {
                    var $cb = $(v);
                    var $sub = $section.find('[data-pk="' + $cb.val() + '"]');
                    if ($sub.length > 0)
                    {
                        $sub.addClass('show');
                    }
                });
                $selected1 = $section.find('input[id^="cl_profs_1_"][type="checkbox"]:checked');
                $.each($selected1, function(k, v) {
                    var $cb = $(v);
                    var $sub = $cb.closest('.sub-1');
                    if ($sub.length > 0)
                    {
                        $sub.addClass('show');
                    }
                });
                // _pri.dbg('    $selected1', $selected1);
                _pri.updSection($section);
            break;

            case 'cl_tags':
                _pri.cl_tags_select = JW.InpSelect(jQuery, $section.find('.jb-select.clsacc')[0]);
                _pri.cl_tags_select.on('inpselect:tags_changed', function(e) {
                    // _pri.dbg('******** cl_tags_select on inpselect:tags_changed');
                    _pri.updSection($section);
                });
                _pri.updSection($section);
            break;

            case 'cl_dist':
                // inited by page ...
                // var $dst_wrp  = $section.find('.dist-wrp.nai');
                // _pri.$dst_inp = $dst_wrp.find('input[type="range"]');
                //
                // if (_pri.$dst_inp.length == 1)
                // {
                //     var $lgd_cur = $dst_wrp.find('.dist-cur');
                //     if ($lgd_cur.length == 1)
                //     {
                //         _pri.$dst_inp.rangeslider({
                //             polyfill: false,
                //             // onInit: _pri.updDstSld,
                //             onSlide: _pri.updDstSld,
                //             onSlideEnd: _pri.updDstSld,
                //             $lgd_cur: $lgd_cur,
                //             unt: _pri.$dst_inp.data('unt')
                //         });
                //         _pri.dbg('*** clsacc.initSection cl_dist ... done');
                //     }
                // }


                _pri.$dst_inp = $section.find('.jw-slider.nai');
                if (_pri.$dst_inp.length == 1)
                {
                    _pri.$dst_dsp = _pri.$dst_inp.parent().find('.dist-cur');
                    _pri.page.initSld(_pri.$dst_inp[0], _pri.updDstSld);
                }

                _pri.updSection($section);
            break;

            default:

            break;
        }
    };

    _pri.hideSection = function(key, hide)
    {
        _pri.dbgG('*** hideSection()');

        if (typeof _pri.sections[key] === 'object')
        {
            var $section = _pri.sections[key];
            if (hide)
            {
                $section.find('input[type="checkbox"]:checked').prop('checked', false);
                $section.find('.collapse').first().collapse('hide');
                $section.removeClass('opn');
                publ.updSection(key);
                $section.slideUp();
            }
            else
            {
                $section.slideDown();
            }
        }
    };

    _pri.extend();
    _pri.init();
    return publ;
};
